<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
    name: "CashButton",
})
</script>

<template>
    <div>
        <el-tooltip popper-class="custom-tooltip" content="Редагувати баланс" placement="top-start">
            <div class="cash-button" @click="$emit('click')">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <rect width="40" height="40" rx="4" fill="#FAFAFA"/>
                    <rect x="12" y="12" width="14" height="14" fill="url(#pattern0_269_8173)"/>
                    <defs>
                        <pattern id="pattern0_269_8173" patternContentUnits="objectBoundingBox" width="1" height="1">
                            <use xlink:href="#image0_269_8173" transform="scale(0.02)"/>
                        </pattern>
                        <image id="image0_269_8173" width="50" height="50" preserveAspectRatio="none" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC20lEQVR4nO2ay2oUURCG/xgwuhECIsZn8LJQ8fYEoiiou7gLJKDGV5iFU9VeF9mpaB4gYnShZOMzGEV9hoSJF8RL3MRfTvVx7LmYTDLnTOfo/NDQdJ+uOtXd56uqngF6JFawjYITVFyh4j4FcxS8peA9BR8p+Ok3t7/kz83ZWHfNNRx3Nno13+bJb6VilIKnVHyjgl1tgq/e1qizHT8AYoCCCQoWCpNwd/sVFQ/sDldxioK9vI2dzDBcvzbDsB27jn1+zCQFD+1aZ+OPvQXzQQzECWIGgxTMFhy+ZIZx3sTurm1XMWK2FPMF+7POZ5jZF50J1DupUXAuuAMvZjhvPvJgFKFlCzUP5Ehw401yPnwgSwgtKpbNeBVHgxtvkvPhb9oXhFaBMjX3+IM78KLgQv3VUhCh1Qab87ZAqxgJstgFEw2LPXoggrG2+M1ROknFaQr28xZ2GXIr2GKb28+PHbAxiqsUTFPxug1+x6IHYvtTGKLgoiUxl8xCJETFE0uIUxhq9hctkJYSRXGMgssU3KPgORVvqFi0skSxYlu+v2jn3Bg3VnHJFraffCf+ogUSS4wYSBn4XQ5vvI/ftcX/Gr/spBHKjXz29dU7Kl4U7tJh3sH2UvDL0I2Q4gMVj3wjtCM6fplwI8TfgaTcCLGI31QbITZXvyk1QlwNv6VkYsF3VnHS1pXHr52vdIHfsjJxcPyypEbIco7LS3lwn/yxlQ3jd9Nl4nWqJZAUGyE24DfRRogt+I1VPf5tAl344ybE7w9mOMsqDvEG9tg6cxVGpY9fbm78Kp5RcbePX6aH39ra+HUodY+3E/yu51UIi1/5F/D72Pqbsr5DUXGGGQ765mtj+M0wXu84k61+K00/hqaO37pSr37rSrn6bVCq+G1RSvhdVfWvKL3Fby28cYWUgF8J72AGg5Yde4ffPBPHEN23Xzf52PgtZuKYYvFrfGj89uJvSWgfVBT8xtIvPKkcHWeMq+YAAAAASUVORK5CYII="/>
                    </defs>
                </svg>
            </div>
        </el-tooltip>
    </div>
</template>

<style scoped lang="scss">
.cash-button {
    cursor: pointer;
}
</style>

<style>
.custom-tooltip {
    background: #D4D3D9 !important;
    color: black !important;
}
</style>
